import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import Breadcrumb from "app/pages/Breadcrumb/Breadcrumb.jsx";
import BreadcrumbItem from "app/pages/Breadcrumb/BreadcrumbItem.jsx";
import "./booking-header.scss";
import SimpleHeaderContainer from "app/pages/Header/SimpleHeader/SimpleHeaderContainer";
import { matchPath } from "react-router-dom";
import CouponsBannerContainer from "app/pages/.shared/CouponsBanner/CouponsBannerContainer";
import { isServerSide } from "app/utils/utils";

const BookingHeader = ({ location = {}, ficheProduitUri }) => {
	// eslint-disable-next-line consistent-return
	useEffect(() => {
		const partnerDynamicHeader = window.document.querySelector(".partner-dynamic-header");

		if (partnerDynamicHeader) {
			partnerDynamicHeader.style.display = "none";
		}

		return () => {
			if (partnerDynamicHeader) {
				partnerDynamicHeader.style.display = "block";
			}
		};
	}, []);

	useEffect(() => {
		// hide header for SP
		if (!isServerSide && window.popupBridge && window.popupBridge.open) {
			const bookingHeader = document.getElementsByClassName("simple-header")[0];

			if (bookingHeader) {
				bookingHeader.style.display = "none";
			}
		}
	}, [location.pathname]);

	const currentPathname = location.pathname;
	const isBookingAuthPage = matchPath(currentPathname, { path: "/booking/auth" });

	const isFirstStep =
		matchPath(currentPathname, {
			path: `/${ficheProduitUri}`,
		}) ||
		matchPath(currentPathname, {
			path: "/booking/search",
		});

	const isQuotationPage = matchPath(currentPathname, {
		path: "/booking/quote",
	});

	const isPaiementPage = matchPath(currentPathname, {
		path: "/booking/payment",
	});

	const isConfirmationPage = matchPath(currentPathname, {
		path: "/booking/confirmation",
	});

	return (
		<header className="booking-header">
			<SimpleHeaderContainer />
			<CouponsBannerContainer />
			<div className="booking-header__breadcrumb">
				<Breadcrumb>
					<BreadcrumbItem
						isActive={Boolean(isFirstStep)}
						isPassed={
							Boolean(isPaiementPage) ||
							Boolean(isQuotationPage) ||
							isBookingAuthPage ||
							Boolean(isConfirmationPage)
						}
						label={<FormattedMessage id="booking.breadcrumb.step.1" />}
						disableClick={true}
					/>
					<BreadcrumbItem
						isActive={Boolean(isQuotationPage)}
						isDisabled={Boolean(isFirstStep)}
						isPassed={
							Boolean(isPaiementPage) ||
							isBookingAuthPage ||
							Boolean(isConfirmationPage)
						}
						label={<FormattedMessage id="booking.breadcrumb.step.2" />}
						disableClick={true}
					/>
					<BreadcrumbItem
						isActive={Boolean(isPaiementPage)}
						isDisabled={Boolean(isFirstStep) || Boolean(isQuotationPage)}
						isPassed={Boolean(isConfirmationPage)}
						label={<FormattedMessage id="booking.breadcrumb.step.3" />}
						disableClick={true}
					/>
					<BreadcrumbItem
						isActive={Boolean(isConfirmationPage)}
						isDisabled={
							Boolean(isFirstStep) ||
							Boolean(isQuotationPage) ||
							Boolean(isPaiementPage)
						}
						label={<FormattedMessage id="booking.breadcrumb.step.4" />}
						disableClick={true}
					/>
				</Breadcrumb>
			</div>
		</header>
	);
};

BookingHeader.propTypes = {
	ficheProduitUri: PropTypes.string,
	location: PropTypes.object,
};

export default BookingHeader;
